import { Flex, Typography, useBreakpointValue } from "@nestoca/ui";
import { useGetApplicationsByApplicantId } from "@shared/api/hooks/applications";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";

import styles from "../application-selector/application-selector.module.scss";

import { SelectedAddress } from "./selected-address";

type ApplicationAddressButtonProps = {
  isMenuOpen?: boolean;
};

export const ApplicationAddressButton = ({
  isMenuOpen,
}: ApplicationAddressButtonProps) => {
  const { t } = useTranslation("applications");
  const { data: applications } = useGetApplicationsByApplicantId();
  const isMobile = useBreakpointValue({ default: true, md: false });

  const atLeastTwoApplications = applications && applications.length >= 2;

  return (
    <Flex
      className={clsx(styles.dashboard, {
        [styles.button]: atLeastTwoApplications,
      })}
      data-testid="application-address"
    >
      {!isMobile && (
        <Typography className={styles["dashboard-heading"]}>
          {t("application.dashboard")}
        </Typography>
      )}
      <Flex gap={2} align="center" className={styles["dashboard-wrapper"]}>
        <SelectedAddress />
        {atLeastTwoApplications && !isMobile && (
          <Chevron isMenuOpen={isMenuOpen} />
        )}
      </Flex>
    </Flex>
  );
};

const Chevron = ({ isMenuOpen }: ApplicationAddressButtonProps) =>
  isMenuOpen ? <BsChevronUp /> : <BsChevronDown />;
